import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { TimeHlp } from 'src/lib/fliko/helpers/time.helper';
import { Collection } from 'src/lib/fliko/types/database.type';
import { tTime } from 'src/lib/fliko/types/time.type';
import { validatePolish } from 'validate-polish';
import { StringHelper } from '../helpers/string.helper';

// TODO unify types - some validators are functions, some - argumentless generators
export class ControlValidators {
  public static dateFromFuture = (control: AbstractControl): Collection<any> | null => {
    const date = TimeHlp.timestamp(control.value);
    if (!date || date > Date.now()) {
      return null;
    }
    return { dateFromFuture: true };
  };

  public static dateFromFutureOrToday = (control: AbstractControl): Collection<any> | null => {
    const date = TimeHlp.timestamp(control.value);
    if (!date || date >= TimeHlp.todayAt(0)) {
      return null;
    }
    return { dateFromFuture: true };
  };

  public static dateFromPast = (control: AbstractControl): Collection<any> | null => {
    const date = TimeHlp.timestamp(control.value);
    if (!date || date < Date.now()) {
      return null;
    }
    return { dateFromPast: true };
  };

  /**
   * Check if control value is in future, or at given initial date
   * @param initialDate
   * @return
   */
  public static dateFromFutureOrInitial(initialDate: tTime): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const date = TimeHlp.timestamp(control.value);
      if (!date || date > Date.now() || TimeHlp.at(date, 0) == TimeHlp.at(initialDate, 0)) {
        return null;
      }
      return { dateFromFutureOrInitial: true };
    };
  }

  // TODO: non-polish ibans
  public static ibanValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let value: string = control.value;
      if (!value) {
        return null;
      }

      value = value.replace(/ /g, '');
      const hasCountry = value.substring(0, 2) == 'PL';
      const length = value.length === 28;
      const allNumbers = /[0-9]{26}/.test(value.substring(2));

      return hasCountry && allNumbers && length ? null : { iban: '' };
    };
  }

  public static negativeValueValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value: number = control.value;
      if (!value) {
        return null;
      }
      return value >= 0 ? null : { negativeValue: '' };
    };
  }

  public static urlValidator(domain?: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value: string = control.value;
      const urlError = Validators.pattern(StringHelper.urlRegex())(control);

      if (urlError) return { url: { value } };

      if (domain) {
        if (!value || value.indexOf(domain) < 0) return { url: { value, domain } };
      }

      return null;
    };
  }

  // TODO: Validator for more countries
  public static zipCodeValidator(): ValidatorFn {
    return (): ValidationErrors | null => {
      // let value: string = control.value;
      // if (!value) {
      //   return null;
      // }

      // const validFormat = /^[0-9]{2}-[0-9]{3}$/;
      // return validFormat.test(value) ? null : { ['zipCode']: '' };
      return null;
    };
  }

  // 10 digits long.
  public static nipValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value: string | null = control.value?.replace(/-/g, '');
      return !value || validatePolish.nip(value) ? null : { nip: value };
    };
  }

  // 9 digits long.
  public static regonValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value: string | null = control.value?.replace(/ /g, '');
      return !value || validatePolish.regon(value) ? null : { regon: value };
    };
  }

  // 13+2 characters long and in format: AAXA/XXXXXXXX/X where X is a digit and A is a letter.
  public static landRegisterValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value: string | null = control.value;
      const validFormat = /^[A-Z]{2}[0-9]{1}[A-Z]{1}\/[0-9]{8}\/[0-9]{1}$/;

      return !value || validFormat.test(value) ? null : { landRegister: value };
    };
  }

  // (KRS) 10 digits long.
  public static krsValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value: string | null = control.value?.replace(/-/g, '');
      const validFormat = /^[0-9]{10}$/;

      return !value || validFormat.test(value) ? null : { krs: value };
    };
  }

  // TODO use control
  /**
   * Check if uploaded file is smaller than given size
   * @param file file object
   * @param max  maximum file size in MB
   * @return
   */
  public static maxFileSize(file: File, max: number): ValidatorFn {
    return (): ValidationErrors | null => {
      return !file || file.size > 1024 * 1024 * max ? { maxFileSize: true } : null;
    };
  }

  // TODO use control
  public static fileType(file: File, mimeTypes: Array<string>): ValidatorFn {
    return (): ValidationErrors | null => (!file || !mimeTypes.includes(file.type) ? { fileType: true } : null);
  }
}
